import React, { Component } from 'react';
import Draggable, { DraggableData } from 'react-draggable';
import 'styled-components/macro';
import * as types from 'styled-components/cssprop'; /* eslint-disable-line  */
import { css, withTheme, Theme, keyframes } from 'styled-components';
import { Context } from '../../i18n';
import { scale, searchObj, isNative, isMobile } from '@/utils/constants';
import SlideIcon from './slide_icon';
import { baseRem } from '@/utils/rem';
import { isRTL } from '@/utils/utils';

const slideShine = keyframes`
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 130% 100%;
  }
`;
// 安卓7.0以下因为卡顿，不支持扫光，PC兼容性差也不支持
const disableShine =
  (searchObj.os_type === '0' &&
    !!searchObj.os_version &&
    searchObj.os_version < '24') ||
  !isNative;
type IProps = {
  onDrag: (e: any, d: DraggableData) => void;
  onSubmit: () => void;
  onEnterSlide: (e: any) => void; // 因为 e 是 合成的，不能使用 Event
  onStart: (e: any, d: DraggableData, dragType: 'img' | 'btn' | 'none') => void;
  sliding: boolean;
  slide_btn_able: boolean;
  drag_type: 'img' | 'btn' | 'none';
  theme: Theme;
  lang: string;
  drag_pos: {
    x: number;
    y: number;
  };
  show_verify_msg: boolean;
  verify_status: 'fail' | 'pass' | 'init';
  isWhirl?: boolean;
};
const setRem = (base: number, target: number) => (base / 100) * (100 / target);
class SlideButton extends Component<IProps> {
  static contextType = Context;
  context!: React.ContextType<typeof Context>;
  render() {
    const {
      onDrag,
      onSubmit,
      onStart,
      onEnterSlide,
      sliding,
      slide_btn_able,
      theme,
      lang,
      drag_pos,
      verify_status,
      isWhirl,
    } = this.props;
    let fontSize = 12;
    if (isWhirl) {
      if (!lang || lang?.startsWith('zh')) {
        fontSize = 14;
      }
    }
    const { slide_prompt, slide_prompt_whirl } = this.context;
    return (
      <div
        className="captcha_verify_slide--button"
        css={css`
          position: relative;
          height: 0.4em;
          text-align: center;
          margin: ${isWhirl ? 0 : 0.04}em 0.12em ${isWhirl ? 0.02 : 0}em;
          direction: ltr;
        `}
        onMouseEnter={onEnterSlide}
      >
        <div
          className="captcha_verify_slide--slidebar"
          css={css`
            width: 100%;
            height: 0.4em;
            text-align: center;
            color: ${theme.slideSlotDescColor};
            background: ${theme.slideSlotBgColor};
            box-sizing: border-box;
            border-radius: ${theme.slideSlotBorderRadius};
          `}
        >
          {/* {sliding && ( */}
          {/* 滑动中 滑块左侧划过的部分 */}
          <span
            className={`secsdk-captcha-slidebar ${
              verify_status === 'fail' ? 'secsdk-captcha-slidebar-fail' : ''
            }`}
            css={css`
              position: absolute;
              left: 0;
              top: 0;
              height: 0.4em;
              border-radius: ${theme.slideBorderRadius} 0px 0px
                ${theme.slideBorderRadius};
              background-color: ${verify_status === 'fail'
                ? theme.slidingSlotErrorBgColor
                : theme.slidingSlotBgColor};
              ${theme.slidingSlotLinearColor &&
              `background: -webkit-linear-gradient(
                    left,
                    ${theme.slidingSlotBgStartColor} 80%,
                    ${theme.slidingSlotBgEndColor}
                  ); /* Safari 5.1 - 6.0 */
                  background: -o-linear-gradient(
                    right,
                    ${theme.slidingSlotBgStartColor} 80%,
                    ${theme.slidingSlotBgEndColor}
                  ); /* Opera 11.1 - 12.0 */
                  background: -moz-linear-gradient(
                    right,
                    ${theme.slidingSlotBgStartColor} 80%,
                    ${theme.slidingSlotBgEndColor}
                  ); /* Firefox 3.6 - 15 */
                  background: linear-gradient(
                    to right,
                    ${theme.slidingSlotBgStartColor} 80%,
                    ${theme.slidingSlotBgEndColor}
                  ); /* 标准的语法 */
                  background: ${theme.slidingSlotLinearColor};`}
            `}
            style={
              slide_btn_able
                ? {
                    width: `${drag_pos.x === 0 ? 0 : drag_pos.x + 3}px`,
                  }
                : {
                    transition: 'all 0.4s',
                    width: `${drag_pos.x === 0 ? 0 : drag_pos.x + 3}px`,
                  }
            }
          />
          {/* )} */}
          {!sliding && (
            <div
              css={css`
                width: 100%;
                height: 100%;
                box-sizing: border-box;
                -moz-box-sizing: border-box;
                padding: 0 0.08em 0 ${isMobile ? '0.6em' : '0.7em'};
                display: flex;
                justify-content: center;
                align-items: center;
                white-space: normal;
                overflow: hidden;
              `}
            >
              <span
                css={css`
                  font-size: ${fontSize / 100}em !important;
                  ${!disableShine &&
                  `background: linear-gradient(
                    90deg,
                    ${theme.shineBlockStartColor} 0%,
                    ${theme.shineBlockEndColor} 50%,
                    rgba(0, 0, 0, 0) 100%
                  )
                  no-repeat 0 0;
                  background-size: 20% 100%;
                  -webkit-background-clip: text;
                  -webkit-text-fill-color: ${theme.shineTextFillColor};`}
                  -webkit-animation: ${slideShine} 2.5s linear infinite;
                  ${isRTL(lang) && 'direction: rtl;'}
                `}
              >
                {isWhirl ? slide_prompt_whirl : slide_prompt}
              </span>
            </div>
          )}
        </div>
        <Draggable
          axis="x"
          bounds={{
            left: 0,
            top: 0,
            right: (baseRem * scale * 220) / 100, // 276 - 52 - 2 * 2 = 220 左右各有 2px
            bottom: 0,
          }}
          onStart={(e, d) => onStart(e, d, 'btn')}
          onDrag={onDrag}
          onStop={onSubmit}
          disabled={!slide_btn_able}
          position={{
            x: drag_pos.x,
            y: 0,
          }}
        >
          <div
            id="secsdk-captcha-drag-wrapper"
            css={css`
              position: absolute;
              top: 0;
              left: 0.02em;
            `}
            style={
              slide_btn_able
                ? {}
                : {
                    transition: 'all 0.4s',
                  }
            }
          >
            {/* {sliding && ( */}
            {/* 滑动中 滑块上下缝隙颜色渐变 */}
            <div
              className={`secsdk-captcha-drag-sliding ${
                sliding && verify_status === 'fail'
                  ? 'secsdk-captcha-drag-sliding-fail'
                  : ''
              }`}
              css={css`
                position: absolute;
                width: 0.44em;
                height: 0.4em;
                top: 0;
                z-index: 1;
                border-radius: ${!drag_pos.x && theme.slideBorderRadius} 0px 0px
                  ${!drag_pos.x && theme.slideBorderRadius};
                background: ${sliding && verify_status === 'fail'
                  ? theme.slidingSlotErrorBgColor
                  : theme.slidingSlotBgColor};
                background: -webkit-linear-gradient(
                  left,
                  ${sliding && verify_status === 'fail'
                    ? theme.slidingSlotErrorBgColor
                    : theme.slidingSlotBgEndColor},
                  ${theme.slideSlotBgColor}
                ); /* Safari 5.1 - 6.0 */
                background: -o-linear-gradient(
                  right,
                  ${sliding && verify_status === 'fail'
                    ? theme.slidingSlotErrorBgColor
                    : theme.slidingSlotBgEndColor},
                  ${theme.slideSlotBgColor}
                ); /* Opera 11.1 - 12.0 */
                background: -moz-linear-gradient(
                  right,
                  ${sliding && verify_status === 'fail'
                    ? theme.slidingSlotErrorBgColor
                    : theme.slidingSlotBgEndColor},
                  ${theme.slideSlotBgColor}
                ); /* Firefox 3.6 - 15 */
                background: linear-gradient(
                  to right,
                  ${sliding && verify_status === 'fail'
                    ? theme.slidingSlotErrorBgColor
                    : theme.slidingSlotBgEndColor},
                  ${theme.slideSlotBgColor}
                ); /* 标准的语法 */
                background: ${drag_pos.x === 0 ? 'none' : ''};
              `}
              style={
                slide_btn_able
                  ? {}
                  : {
                      transition: 'all 0.4s',
                    }
              }
            />
            {/* )} */}
            <div
              className="secsdk-captcha-drag-icon"
              css={css`
                position: absolute;
                z-index: 2;
                background-color: ${theme.slideBgColor};
                box-sizing: border-box;
                box-shadow: 0 0 2px 0 ${theme.slideBorderColor};
                top: 0.02em;
                width: ${(52 * scale) / 100}em;
                height: 0.36em;
                cursor: pointer;
                border-radius: ${theme.slideBorderRadius};
              `}
              onMouseMove={(e: any) => {
                if (e.stopPropagation) e.stopPropagation();
                else if (window.event) {
                  window.event.cancelBubble = true;
                }
              }}
            >
              <div
                css={css`
                  width: 0.22em;
                  height: 0.2em;
                  position: absolute;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  top: 0;
                  margin: auto auto;
                  svg {
                    display: block;
                    width: 100%;
                    height: 100%;
                  }
                `}
              >
                <SlideIcon slideIconColor={theme.slideIconColor} />
              </div>
            </div>
          </div>
        </Draggable>
      </div>
    );
  }
}

export default withTheme(SlideButton);
